import GoTrue from "gotrue-js";

export const auth = new GoTrue({
    APIUrl: "https://staff.karanteeni.net/.netlify/identity",
    audience: "",
    setCookie: true
});

const state = {
    currentUser: getSavedState("auth.currentUser"),
    loading: false,
    loggedIn: false,
    token: null,
    notifications: [],
    rememberMe: getSavedState("auth.rememberMe")
};

function getSavedState(key) {
    return JSON.parse(window.localStorage.getItem(key));
}

export default state;